// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"960":"63683ce0","2345":"0a91f43f"}[chunkId] + ".chunk.css";
};